import _implicitStylesheets from "./carouselV2.css";
import _implicitScopedStylesheets from "./carouselV2.scoped.css?scoped=true";
import _listingLightboxV2 from "listing/lightboxV2";
import _axImage from "ax/image";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _listingVideoPreviewV2 from "listing/videoPreviewV2";
import _axIcon from "ax/icon";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="screen-reader-only${0}" role="status" aria-live="polite"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<button${"c0"} type="button"${"a0:data-index"}${"a0:aria-label"}${"a0:aria-current"}${2}></button>`;
const stc0 = {
  "carousel-v2": true
};
const stc1 = {
  classMap: {
    "gallery": true
  },
  key: 4
};
const stc2 = {
  classMap: {
    "selected-column": true
  },
  key: 5
};
const stc3 = {
  "selected-media": true
};
const stc4 = {
  "selected-media-action": true
};
const stc5 = {
  "interactive-preview": true
};
const stc6 = {
  "data-testid": "carousel-v2-media-rail"
};
const stc7 = {
  "rail-item": true
};
const stc8 = {
  classMap: {
    "rail-media-type": true
  },
  key: 15
};
const stc9 = {
  props: {
    "icon": "play",
    "spriteUrl": "/images/icons.svg",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 16
};
const stc10 = {
  classMap: {
    "controls": true
  },
  key: 17
};
const stc11 = {
  classMap: {
    "controls-inner": true
  },
  key: 18
};
const stc12 = {
  "nav-button": true,
  "previous": true
};
const stc13 = {
  "data-testid": "carousel-v2-previous"
};
const stc14 = {
  "pagination": true
};
const stc15 = {
  "nav-button": true,
  "next": true
};
const stc16 = {
  "data-testid": "carousel-v2-next"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, gid: api_scoped_id, k: api_key, i: api_iterator, h: api_element, ncls: api_normalize_class_name} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15} = $ctx;
  return [$cmp.showLightbox ? api_custom_element("listing-lightbox-v2", _listingLightboxV2, {
    props: {
      "items": $cmp.lightboxItems,
      "initialItemPosition": $cmp.initialLightboxItemPosition,
      "ga4EventType": "carousel"
    },
    key: 0,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.closeLightbox))
    }
  }) : null, api_element("section", {
    classMap: stc0,
    attrs: {
      "aria-roledescription": "carousel",
      "aria-label": $cmp.labels.ariaDescription
    },
    key: 1,
    on: {
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleKeyDown))
    }
  }, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.selectedMediaAnnouncement))]), $cmp.selectedMediaItem ? api_element("div", stc1, [api_element("div", stc2, [api_element("div", {
    classMap: stc3,
    attrs: {
      "id": api_scoped_id("carousel-v2-selected-media"),
      "data-testid": "carousel-v2-selected-media"
    },
    key: 6,
    on: {
      "touchstart": _m2 || ($ctx._m2 = api_bind($cmp.handleTouchStart)),
      "touchend": _m3 || ($ctx._m3 = api_bind($cmp.handleTouchEnd)),
      "touchcancel": _m4 || ($ctx._m4 = api_bind($cmp.handleTouchCancel))
    }
  }, [$cmp.isSelectedImage ? api_element("button", {
    classMap: stc4,
    attrs: {
      "type": "button",
      "aria-label": $cmp.selectedMediaItem.altText,
      "data-testid": "carousel-v2-selected-action"
    },
    key: 7,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleSelectedMediaClick))
    }
  }, api_iterator($cmp.selectedMediaItems, function (item) {
    return api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: {
        "type": "image",
        "positionIndex": $cmp.selectedItem
      },
      key: api_key(8, item.key),
      on: {
        "analytics": _m6 || ($ctx._m6 = api_bind($cmp.handleImageShown))
      }
    }, [api_custom_element("ax-image", _axImage, {
      props: {
        "imgSrc": item.previewSrc,
        "alt": item.altText,
        "width": "100%",
        "height": "100%"
      },
      key: 9
    })]);
  })) : null, $cmp.isSelectedVideo ? api_element("button", {
    classMap: stc5,
    attrs: {
      "type": "button",
      "aria-label": $cmp.selectedMediaItem.altText,
      "data-testid": "carousel-v2-selected-action"
    },
    key: 10,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.handleSelectedMediaClick))
    }
  }, [api_custom_element("listing-video-preview-v2", _listingVideoPreviewV2, {
    props: {
      "positionIndex": $cmp.selectedItem,
      "posterSrc": $cmp.selectedMediaItem.previewSrc,
      "altText": $cmp.selectedMediaItem.altText
    },
    key: 11
  })]) : null])]), $cmp.hasMultipleItems ? api_element("div", {
    className: api_normalize_class_name($cmp.mediaRailClass),
    attrs: stc6,
    key: 12
  }, api_iterator($cmp.railItems, function (item) {
    return api_element("button", {
      classMap: stc7,
      attrs: {
        "type": "button",
        "data-index": item.key,
        "aria-label": item.altText
      },
      key: api_key(13, item.key),
      on: {
        "click": _m8 || ($ctx._m8 = api_bind($cmp.handleSelect)),
        "keydown": _m9 || ($ctx._m9 = api_bind($cmp.handleThumbnailKeyDown))
      }
    }, [api_custom_element("ax-image", _axImage, {
      props: {
        "imgSrc": item.previewSrc,
        "alt": "",
        "width": "100%",
        "height": "100%"
      },
      key: 14
    }), item.isInteractive ? api_element("span", stc8, [api_custom_element("ax-icon", _axIcon, stc9)]) : null]);
  })) : null, $cmp.hasMultipleItems ? api_element("div", stc10, [api_element("div", stc11, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc12,
    attrs: stc13,
    props: {
      "type": "button",
      "variant": "secondary",
      "icon": "back",
      "iconSpriteUrl": "/images/icons.svg",
      "name": "listing carousel previous",
      "ariaLabel": $cmp.labels.back,
      "ariaControls": api_scoped_id("carousel-v2-selected-media")
    },
    key: 19,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handlePrevious)),
      "analytics": _m11 || ($ctx._m11 = api_bind($cmp.handlePreviousAnalytics))
    }
  }), api_element("div", {
    classMap: stc14,
    style: $cmp.paginationStyle,
    attrs: {
      "role": "group",
      "aria-label": $cmp.selectedMediaAnnouncement
    },
    key: 20
  }, api_iterator($cmp.paginationItems, function (item) {
    return api_static_fragment($fragment2, api_key(22, item.key), [api_static_part(0, {
      on: {
        "click": _m13 || ($ctx._m13 = api_bind($cmp.handleSelect))
      },
      className: api_normalize_class_name(item.className),
      attrs: {
        "data-index": item.key,
        "aria-label": item.ariaLabel,
        "aria-current": item.ariaCurrent
      }
    }, null)]);
  })), api_custom_element("wds-button", _wdsButton, {
    classMap: stc15,
    attrs: stc16,
    props: {
      "type": "button",
      "variant": "secondary",
      "icon": "forward",
      "iconPlacement": "end",
      "iconSpriteUrl": "/images/icons.svg",
      "name": "listing carousel next",
      "ariaLabel": $cmp.labels.forward,
      "ariaControls": api_scoped_id("carousel-v2-selected-media")
    },
    key: 23,
    on: {
      "click": _m14 || ($ctx._m14 = api_bind($cmp.handleNext)),
      "analytics": _m15 || ($ctx._m15 = api_bind($cmp.handleNextAnalytics))
    }
  })])]) : null]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5nd4rjl2aj6";
tmpl.legacyStylesheetToken = "undefined-_carouselV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
